import { useEffect } from "react";

const useSidebarToggle = () => {
  useEffect(() => {
    const menuToggle = document.getElementById("sidebar-hide");
    const sidebar = document.querySelector(".pc-sidebar");

    if (!menuToggle || !sidebar) return;

    const toggleSidebar = () => {
      sidebar.classList.toggle("pc-sidebar-hide");
    };

    menuToggle.addEventListener("click", toggleSidebar);

    return () => {
      menuToggle.removeEventListener("click", toggleSidebar);
    };
  }, []);
};

export default useSidebarToggle;
